import React from 'react';
import { EChartsPresenter } from '../../EChartsView';
import { EChartsData, EChartsSeries } from '../../EChartsView';

export interface ChartViewProps {
    xAxisData?: string[] | Date[];
    data?: (number | null)[];
    /** Plusieurs séries (ex. une par phase L1/L2/L3) — prioritaire sur xAxisData/data */
    multiSeries?: EChartsSeries[];
    label?: string;
    titleTop?: string;
    titleRight?: string;
    title?: string;
    valueMax?: number;
    handleNextWindow?: () => void;
    handlePrevWindow?: () => void;
    unit?: string;
  }

export default function ChartLineView({xAxisData = [], data = [], multiSeries, label, title, titleTop, titleRight, handleNextWindow, handlePrevWindow, unit}: ChartViewProps) {

  const yAxisLabel = unit ? `${label ?? 'Valeur'} (${unit})` : (label || 'Valeur')

  if (multiSeries && multiSeries.length > 0) {
    return (
      <EChartsPresenter
        data={multiSeries}
        title={titleTop || label || 'Graphique'}
        type="line"
        height={400}
        xAxisLabel="Date"
        yAxisLabel={yAxisLabel}
        showLegend={true}
        showTooltip={true}
      />
    );
  }

   // Conversion des données pour ECharts
   const echartsData: EChartsData[] = xAxisData.map((date, index) => {
     const name = typeof date === 'string' 
       ? date 
       : date.toLocaleDateString('fr-FR', {
           year: 'numeric',
           month: 'short',
           day: 'numeric'
         });
     
     return {
       name,
       value: data[index] ?? null,
       color: '#3b82f6'
     };
   });

  return (

      <EChartsPresenter
        data={echartsData}
        title={titleTop || label || 'Graphique'}
        type="line"
        height={400}
        xAxisLabel="Date"
        yAxisLabel={yAxisLabel}
        showLegend={false}
        showTooltip={true}
      />
  
  )
}
